import type { NewsItem } from 'hb-react/frontoffice/apps/NewsIndex/utils/types';
import { axiosWithSyntaxHandlers as axios } from 'hb-react/shared/utils/axios';

export const fetchNews = (
  url: string,
  signal: AbortSignal,
  params: unknown = {},
) =>
  axios
    .get<{ news: NewsItem[]; totalItems: number }>(url, { params, signal })
    .then(({ data }) => ({
      items: data.news,
      totalItems: data.totalItems,
    }));
